import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRouteV2 from 'commons-ui/src/permission/AuthorizedRoute';
import { BULK_ACTIONS_RESOURCES, ACTION, PAGE_NAMES } from 'constant';
import ListBulkReply from './submodules/list/List';
import CreateBulkReply from './submodules/create';

const BulkRefund: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRouteV2
				exact
				configPageName={PAGE_NAMES.bulkActions}
				configResourceName={BULK_ACTIONS_RESOURCES.bulkReply}
				configActionName={ACTION.listBulkReply}
				path={`${path}/list`}
				component={ListBulkReply}
			/>
			<AuthorizedRouteV2
				exact
				configPageName={PAGE_NAMES.bulkActions}
				configResourceName={BULK_ACTIONS_RESOURCES.bulkReply}
				configActionName={ACTION.executeBulkReply}
				path={`${path}/create`}
				component={CreateBulkReply}
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default BulkRefund;
